import script from "./CompletedCoursesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedCoursesModal.vue?vue&type=script&setup=true&lang=js"

import "./CompletedCoursesModal.vue?vue&type=style&index=0&id=6836bd8c&lang=css"

const __exports__ = script;

export default __exports__